<div class="autocomplete-suffix-actions">
  <button
    mat-icon-button
    type="button"
    [attr.aria-label]="clearAriaLabel"
    [style.visibility]="preserveClearSlot ? (showClear ? 'visible' : 'hidden') : null"
    [disabled]="clearDisabled || !showClear"
    *ngIf="preserveClearSlot || showClear"
    (click)="onClearClick($event)">
    <mat-icon>clear</mat-icon>
  </button>

  <button
    mat-icon-button
    type="button"
    [attr.aria-label]="toggleAriaLabel"
    [disabled]="toggleDisabled"
    (click)="onToggleClick($event)">
    <mat-icon>{{ panelOpen ? 'arrow_drop_up' : 'arrow_drop_down' }}</mat-icon>
  </button>
</div>
